import { language } from '@tencent/ppd-base-libs';
import zhCnConfig from '@/i18n/zh-cn/main.json';
import enConfig from '@/i18n/en/main.json';
import zhHkConfig from '@/i18n/zh-hk/main.json';
let langConfig = zhHkConfig; // 默认语言

/**
 * 语言map
 */
const langMap = {
  'zh-hk': zhHkConfig,
  'zh-cn': zhCnConfig,
  en: enConfig,
};

/**
 * 初始化配置
 */
function init(): void {
  const lang = language.getLanguage();
  if (langMap[lang]) {
    langConfig = langMap[lang];
  }
}
export function i18n(key: string, data?: object) {
  let value = langConfig[key];
  if (data && value) {
    // 说明有要替换的
    value = value.replace(/{{([^}]+)}}/g, (...arg) => {
      const replaceKey = arg[1];
      return data[replaceKey];
    });
    return value;
  }
  if (!value) {
    return key;
  }
  return value;
}
export const install = {
  install: (Vue) => {
    Vue.prototype.$t = i18n;
  },
};
init();
